import React from 'react'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IProposalToBeReviewedStageProps } from '../stages/interfaces/IProposalToBeReviewedStageProps'
import { HomeStaticData } from '../homeStaticData'
import { useTheme } from '@emotion/react'
const ProposalToBeReviewedStage = (props: IProposalToBeReviewedStageProps) => {
  const {
    firstName,
    consultantFirstName,
    vehicleDescription,
    isSparta,
    estimateLink,
    reviewProposalLink,
  } = props

  const spartaText = isSparta ? ' Please accept it in a timely manner.' : ''
  const bannerArgs = {
    firstName: firstName,
    consultantFirstName: consultantFirstName,
    isSparta: spartaText,
    vehicleDescription: vehicleDescription,
  }
  const theme = useTheme()
  const sectionTitle = `It's time to give your tick of approval ${firstName}!`
  const firstButton = {
    buttonName: 'Review my proposal',
    disabled: false,
    linkUrl: reviewProposalLink,
  }
  const secondButton = {
    buttonName: 'View my estimates again',
    disabled: false,
    linkUrl: estimateLink,
  }
  return (
    <>
      <BannerBrandImageSection
        sectionContent={HomeStaticData('ProposalReviewBannerText', bannerArgs)}
        sectionTitle={sectionTitle}
        firstButton={firstButton}
        secondButton={secondButton}
        bannerImageName="Banner1"
      >
        <E.ContainerBlock theme={theme}>
          <E.BannerButtonLinkParent>
            <Col sm={7}>
              <E.BannerButtonTitleRow id="proposaltobereviewedstage.tickofapprovalfirstname">
                It's time to give your tick of approval {firstName}!
              </E.BannerButtonTitleRow>
              <Row>
                <div id="proposaltobereviewedstage.maincontent">
                  {HomeStaticData('ProposalReviewBannerText', bannerArgs)}
                </div>
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              <Link to={reviewProposalLink} tabIndex={-1}>
                <E.BannerTopButton
                  extendInMob
                  id="proposaltobereviewedstage.reviewbutton"
                >
                  Review my proposal
                </E.BannerTopButton>
              </Link>

              <br />
              <br />
              <Link to={estimateLink} tabIndex={-1}>
                <E.BannerBottomButton
                  extendInMob
                  id="proposaltobereviewedstage.viewestimates"
                >
                  View my estimates again
                </E.BannerBottomButton>
              </Link>
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default ProposalToBeReviewedStage
